import { render } from "./select.md?vue&type=template&id=57eac01b"
import script from "./select.md?vue&type=script&lang=js"
export * from "./select.md?vue&type=script&lang=js"
script.render = render

export default script